/**
 * Русский каталог копий для функции Books & Rules / campaign
 * (`@gamecodex/world-ui` → `features/books`).
 *
 * Ключи отражают вызовы `t('books.*')` в компонентах функции React. Значения
 * — это точные исходные русские строки, извлечённые во время локализационной обработки.
 */
export const booksRu = {
  // BackerDownloadModal.tsx
  'books.backerModal.title': 'Получите ваш PDF спонсора',
  'books.backerModal.sendLinkError': 'Не удалось отправить ссылку входа прямо сейчас. Попробуйте снова в ближайшее время.',
  'books.backerModal.checkInboxPrefix': 'Проверьте вашу почту на',
  'books.backerModal.checkInboxSuffix':
    'Если вы спонсировали проект с помощью этого адреса, ссылка входа уже в пути — нажмите на неё, чтобы получить вашу копию.',
  'books.backerModal.linkAutoSignIn': 'Ссылка откроет этот сайт и автоматически вас авторизует. Пароль не требуется.',
  'books.backerModal.signInIntro':
    'Введите электронный адрес, с которым вы спонсировали проект. Мы отправим одноклассную ссылку входа, а затем подготовим вашу личную копию.',
  'books.backerModal.pledgeEmailLabel': 'Электронный адрес спонсора',
  'books.backerModal.emailLinkCta': 'Отправить ссылку входа на электронную почту',
  'books.backerModal.prepareTimeout':
    'Подготовка вашей копии занимает дольше, чем ожидалось. Пожалуйста, попробуйте снова в течение нескольких минут.',
  'books.backerModal.notEntitled': 'Вы вошли, но ваш взнос не включает эту книгу.',
  'books.backerModal.notClaimable': 'Эта книга не предлагается как загрузка для спонсоров.',
  'books.backerModal.prepareError': 'Не удалось подготовить вашу загрузку прямо сейчас. Попробуйте снова в ближайшее время.',
  'books.backerModal.signedInAs': 'Вход выполнен как',
  'books.backerModal.signOut': 'Выход',
  'books.backerModal.verified': 'Проверено',
  'books.backerModal.welcomeBack': ' — добро пожаловать обратно,',
  'books.backerModal.backerNumber': '(Спонсор #{number})',
  'books.backerModal.copyReady':
    'Ваша личная копия готова. Эта ссылка личная и вскоре истечёт — пожалуйста, не делитесь ею.',
  'books.backerModal.downloadPdf': 'Скачать ваш PDF',
  'books.backerModal.dtrpgEmailLabel': 'Электронный адрес аккаунта DriveThruRPG',
  'books.backerModal.optional': '(по желанию)',
  'books.backerModal.dtrpgWarn':
    'Добавьте это, чтобы также зеркалировать покупку в вашу библиотеку DriveThruRPG. Пропустите это, и ваша копия все ещё будет доступна здесь.',
  'books.backerModal.preparingCopy': 'Подготовка вашей копии…',
  'books.backerModal.prepareDownload': 'Подготовить и загрузить',

  // BackerVerifyPage.tsx
  'books.backerVerify.missingToken': 'Эта ссылка входа не содержит токена. Запросите новую ссылку со страницы книги.',
  'books.backerVerify.invalidToken':
    'Эта ссылка входа недействительна или истекла. Запросите новую со страницы книги.',
  'books.backerVerify.seoTitle': 'Вход спонсора',
  'books.backerVerify.seoDescription': 'Проверка вашей ссылки входа спонсора Grymwyrd.',
  'books.backerVerify.confirming': 'Подтверждение входа спонсора…',
  'books.backerVerify.signedInHeading': 'Вы вошли',
  'books.backerVerify.signedInAs': 'Вход выполнен как',
  'books.backerVerify.headBackPrefix': 'Вернитесь к книге и нажмите',
  'books.backerVerify.downloadWord': 'Загрузить',
  'books.backerVerify.headBackSuffix': 'чтобы получить вашу копию.',
  'books.backerVerify.backToBook': 'Вернуться к вашей книге',
  'books.backerVerify.browseAthenaeum': 'Просмотреть Библиотеку',
  'books.backerVerify.problemHeading': 'Проблема со ссылкой входа',

  // BookCard.tsx
  'books.card.viewAria': 'Просмотреть {title}',
  'books.card.coverAlt': 'Обложка {title}',
  'books.card.owned': 'Куплено',

  // BookCover.tsx
  'books.cover.coverAlt': 'Обложка {title}',

  // BookStorePage.tsx
  'books.store.seoTitle': 'Книги и правила',
  'books.store.seoDescription':
    'Томы вечных сумерек — основные книги правил, иллюстрированный SRD и мрачные приключения. Покупайте, чтобы разблокировать модули и получать монеты.',
  'books.store.eyebrow': 'Библиотека',
  'books.store.heading': 'Книги и правила',
  'books.store.intro':
    'Приобретите томы, которые связывают мир воедино. Каждая покупка разблокирует воспроизводимые модули в ваших кампаниях и вознаградит вас монетами для внутриигровой экономики.',
  'books.store.filterAria': 'Фильтровать книги по типу',
  'books.store.filterAll': 'Все',
  'books.store.loading': 'Вскрытие архива…',
  'books.store.empty': 'Пока нет томов, соответствующих этой категории. Писцы ещё работают.',

  // BuyButton.tsx
  'books.buy.checkoutUnavailable': 'Оформление покупки пока недоступно. Попробуйте снова в ближайшее время.',
  'books.buy.signInToClaim': 'Войдите, чтобы получить этот том.',
  'books.buy.ledgerSealed': 'Реестр торговца запечатан — оформление покупки появится вскоре.',
  'books.buy.inLibrary': 'В вашей библиотеке',
  'books.buy.openingVault': 'Открытие сейфа…',
  'books.buy.claimFree': 'Получить бесплатно',
  'books.buy.buyPrice': 'Купить — {price}',
  'books.buy.unlockPrefix': 'Купить → разблокировать модули +',
  'books.buy.coinsSuffix': '{coins} монет',

  // BookDetailPage.tsx
  'books.detail.loading': 'Листание страниц…',
  'books.detail.backToAthenaeum': 'Вернуться в Библиотеку',
  'books.detail.unlockOwned': 'Вы владеете этим томом — его учения Grymwyrd разблокированы по всей энциклопедии.',
  'books.detail.unlockClaim': 'Получите этот том, чтобы разблокировать его учения Grymwyrd по всей энциклопедии.',
  'books.detail.returnTo': 'Вернуться к {label}',
  'books.detail.backerCta': 'Спонсор? Загрузите ваш PDF',
  'books.detail.coinsEarned': 'Вы получили {coins} монет от этой покупки.',
  'books.detail.coinsGranted': 'Покупка даёт {coins} монет в ваше сокровищницу.',
  'books.detail.byAuthor': 'Автор: {author}',
  'books.detail.statPrice': 'Цена',
  'books.detail.statPages': 'Страницы (последний рендер)',
  'books.detail.statWords': 'Слова (последний рендер)',
  'books.detail.ofThisTome': 'об этом томе',
  'books.detail.noDescription': 'Для этого тома ещё не написано описание.',
  'books.detail.previewHeading': 'Предпросмотр',
  'books.detail.previewBlurb': 'Взгляните на образец этого тома перед его получением.',
  'books.detail.readPreview': 'Прочитать предпросмотр',
  'books.detail.tocHeading': 'Оглавление',
  'books.detail.tocEmpty': 'Содержание этого тома ещё не каталогизировано.',
  'books.detail.pageAbbrev': 'с. {page}',
  'books.detail.unlockedHeading': 'Разблокированные записи энциклопедии',
  'books.detail.unlockedOwnedNote': 'Теперь часть вашей живой энциклопедии:',
  'books.detail.unlockedLockedNote':
    'Купите этот том, чтобы записать его существ, заклинания и секреты в вашу энциклопедию — и получить',
  'books.detail.coinsAmount': '{coins} монет',
  'books.detail.attributionsHeading': 'Благодарности и лицензирование',
  'books.detail.attributionSource': 'Источник',
  'books.detail.attributionLink': 'ссылка',

  // CampaignLandingPage.tsx
  'books.campaign.liveCampaign': 'Активная кампания',
  'books.campaign.backThisProject': 'Спонсировать проект',
  'books.campaign.viewStretchGoals': 'Посмотреть цели растяжки',
  'books.campaign.pledged': 'Собрано',
  'books.campaign.backers': 'Спонсоры',
  'books.campaign.pitchHeading': 'Концепция',
  'books.campaign.backerUnlockedHeading': 'Записи, разблокированные спонсорами',
  'books.campaign.backerUnlockedBlurb':
    'Спонсоры получают ранний доступ к контенту, который сразу попадает в живую энциклопедию. Вот образец того, что уже утверждено:',
  'books.campaign.previewsEmpty': 'Новые учения записываются — загляните, когда цели будут достигнуты.',
  'books.campaign.choosePledge': 'Выберите взнос',
  'books.campaign.mostBacked': 'Самый популярный',
  'books.campaign.pledgeAmount': 'Взнос {amount}',
  'books.campaign.pledgeFooter':
    'Взносы обрабатываются безопасно при оформлении покупки. Награды за спонсорство (монеты, модули и разблокировки энциклопедии) предоставляются вашему аккаунту Grymwyrd после того, как служба кампании запустится.',

  // LanguageSelect.tsx
  'books.language.label': 'Язык',

  // PreviewModal.tsx
  'books.preview.title': 'Предпросмотр — {title}',
  'books.preview.pdfAria': 'Предпросмотр PDF {title}',
  'books.preview.cannotDisplay': 'Ваш браузер не может отобразить предпросмотр inline.',
  'books.preview.openNewTab': 'Открыть предпросмотр в новой вкладке',
  'books.preview.preparingHeading': 'Предпросмотр подготавливается.',
  'books.preview.preparingBody':
    'Образец этого тома переписывается скрипториумом и вскоре появится здесь. Пока что, взгляните, что находится внутри:',
  'books.preview.excerptLabel': 'Выдержка — {title}',
  'books.preview.excerptFallback':
    'По ту сторону этого порога лежат страницы, пропитанные ужасом и чудом. Приобретите том, чтобы прочитать дальше.',
  'books.preview.noExcerpt': 'Для этого тома ещё не каталогизирована выдержка.',

  // RulesPage.tsx
  'books.rules.sectionSpells': 'Заклинания',
  'books.rules.sectionMonsters': 'Враги',
  'books.rules.sectionMagicItems': 'Магические предметы',
  'books.rules.sectionWeapons': 'Оружие',
  'books.rules.sectionArmor': 'Доспехи',
  'books.rules.sectionSkills': 'Навыки',
  'books.rules.entriesCount': '{entries} записей',
  'books.rules.readingLabel': 'Чтение {label}…',
  'books.rules.noneCatalogued': 'Нет {label}, каталогизированных в этой системе.',
  'books.rules.browseAll': 'Просмотреть все {label} в энциклопедии →',
  'books.rules.seoTitle': 'Правила и SRD',
  'books.rules.seoDescription':
    'Просмотрите Документ системной справки — заклинания, врагов, предметы и правила, что связывают вечные сумерки. 5e SRD сейчас, вскоре появятся другие системы.',
  'books.rules.eyebrow': 'Кодекс',
  'books.rules.heading': 'Правила и системная справка',
  'books.rules.intro':
    'Открытый игровой контент, питающий Grymwyrd. Просмотрите записи, относящиеся к правилам, и погрузитесь в полную энциклопедию для блоков статов и истории. Grymwyrd поставляется с 5e SRD сегодня — PF2e и другие системы появятся вскоре.',
  'books.rules.loading': 'Консультация кодекса…',
  'books.rules.gameSystems': 'Игровые системы',
  'books.rules.noSystems': 'Пока нет зарегистрированных игровых систем.',
  'books.rules.openSrd': 'Открыть SRD',
  'books.rules.lockedComingSoon': 'Заблокирована — появится вскоре',
  'books.rules.referenceContent': '{name} — справочный контент',
  'books.rules.releasedUnder': 'Выпущено под {license}',
  'books.rules.licenseLink': 'лицензия',

  // StretchGoals.tsx
  'books.stretch.goalProgressAria': 'Прогресс финансирования {title}',
  'books.stretch.unlockedAdded': 'Разблокирована — добавлена в энциклопедию',
  'books.stretch.percentFunded': '{pct}% профинансировано',
  'books.stretch.autoPopulates': 'Автоматически заполняет энциклопедию',
  'books.stretch.raisedSoFar': 'Собрано на данный момент',
  'books.stretch.backers': 'Спонсоры',
  'books.stretch.overallAria': 'Общее финансирование кампании',
  'books.stretch.heading': 'Цели растяжки',
} as const
